import { Component } from 'react';

export default class Membership extends Component {
  // UI - Design
  render() {
    return (
      <div>
        <section className="py-5">
          <div className="container">
            <div className="pricing-box p-5 text-center shadow rounded bg-white">
              {/* Title */}
              <div className="section-title text-center mb-4">
                <h2 className="membership-title">Your Membership Details</h2>
                <div className="divider mx-auto my-3" style={{ width: "60px", height: "3px", backgroundColor: "#7d1919" }}></div>
              </div>

              {/* Plan Summary */}
              <h4 className="mb-3 mt-4">One Year Membership (365 Days)</h4>

              {/* Info */}
              <p className="mb-3">
                You are currently an <strong>Active Member</strong> with full access to Varenya Matrimonial services.
                <br />
                Membership valid till <strong style={{ color: '#7d1919' }}>July 8, 2026</strong>.
              </p>

              {/* Note */}
              <div className="alert alert-light mb-0">
                <strong>Renewal will be available from July 1, 2026</strong>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
